import React from "react";
import {Column} from "../../ui/spectre/grid";
import {useRouteLoaderData} from "react-router-dom";
import CopyableInviteLink from "./copyableInviteLink";
import {FormatDate} from "../../../../helper/dateTime";
import {Button, ButtonTypes} from "../../ui/spectre/buttons";
import {Icon} from "../../ui/spectre/icon";

/**
 * @param invite {groupInvite}
 * @param onDelete {function}
 * @returns {JSX.Element}
 * @constructor
 */
export default function GroupInvite({ invite, onDelete }) {
    /**
     * @type {groupDataType}
     */
    const groupData = useRouteLoaderData('group');

    return <>
        <Column sizes={[3]}>{groupData.roles[invite.role]?.rolename ?? '?'}</Column>
        <Column sizes={[3]}><CopyableInviteLink link={invite.link} size={16} /></Column>
        <Column sizes={[2]}>{FormatDate(invite.created)}</Column>
        <Column sizes={[2]}>?</Column>
        <Column sizes={[2]}>
            <Button buttonTypes={[ButtonTypes.small]} onClick={onDelete}><Icon type={'delete'} /></Button>
        </Column>
    </>
}
